import { EventEmitter, Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BroadcasterService extends EventEmitter {
  constructor(@Inject('$rootScope') private $rootScope: any) {
    super();
  }

  emit(event: String) {
    super.emit(event);

    this.$rootScope.$broadcast(event);
  }

  emitWithParams(event: String, param: any) {
    super.emit(event);

    this.$rootScope.$broadcast(event, param);
  }

  on(watchedEvent: String, callback: Function) {
    const subscription = this.subscribe((event: string) => {
      if (event === watchedEvent) {
        callback();
      }
    });
    return subscription;
  }
}
